import React from 'react';
import { Link } from 'react-router-dom';
type ButtonProps = {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'text';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  href?: string;
  to?: string;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
};
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  href,
  to,
  onClick,
  disabled = false,
  type = 'button'
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variantStyles = {
    primary: 'bg-[#FF6B65] text-white hover:bg-[#FF6B65]/90 focus:ring-[#FF6B65]',
    secondary: 'bg-[#0099A1] text-white hover:bg-[#0099A1]/90 focus:ring-[#0099A1]',
    outline: 'border border-[#0099A1] text-[#0099A1] hover:bg-[#0099A1]/10 focus:ring-[#0099A1]',
    text: 'text-[#0099A1] hover:text-[#0099A1]/90 focus:ring-[#0099A1]'
  };
  const sizeStyles = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg'
  };
  const styles = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`;
  if (href) {
    return <a href={href} className={styles} target="_blank" rel="noopener noreferrer" data-id="element-326">
        {children}
      </a>;
  }
  if (to) {
    return <Link to={to} className={styles} data-id="element-327">
        {children}
      </Link>;
  }
  return <button type={type} className={styles} onClick={onClick} disabled={disabled} data-id="element-328">
      {children}
    </button>;
}